import { render } from "./BrandShowDetail.vue?vue&type=template&id=24dc66b3&scoped=true"
import script from "./BrandShowDetail.vue?vue&type=script&lang=js"
export * from "./BrandShowDetail.vue?vue&type=script&lang=js"

import "./BrandShowDetail.vue?vue&type=style&index=0&id=24dc66b3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dc66b3"]])

export default __exports__